import { takeLatest } from 'redux-saga/effects';
import { fetchAppConfigWorkerSaga } from './appConfigurationWorkerSaga';
import { FETCH_APP_CONFIG_REQUEST } from '../../redux/modules/appConfiguration/appConfiguration-actions';

export function* fetchAppConfigWatcherSaga() {
    yield takeLatest(FETCH_APP_CONFIG_REQUEST, fetchAppConfigWorkerSaga);
}

export default fetchAppConfigWatcherSaga;
